<template>
    <b-modal title="Filter By Your Custom Fields" :id="'custom-data-filter' + prefix" size="sm">
        <div>
            <p>Select the field you want to use, then the values you want to filter by.</p>

            <div v-for="(filter, index) in filters" :key="filter.id">

                <select v-model="filters[index].id" @change="resetFilter(index)" class="multiselect__input selectbox selectbox-mid">
                    <option value="0">
                        Select field
                    </option>
                    <template v-for="(filterItem, id) in actualFiltersList(filters[index].id)">
                        <option v-if="['text','textarea','date','numeric','radio','checkbox', 'select', 'multiselect', 'users_list'].indexOf(filterItem.type) >= 0" :key="id" :value="id">
                            {{filterItem.name}}
                        </option>
                    </template>
                </select>

                <div class="d-flex align-items-center">
                    <template v-if="filter.id > 0">
                        <input class="form-control form-control--mid mb-2" v-if="filtersList[filter.id].type == 'text' || filtersList[filter.id].type == 'textarea'" v-model="filters[index].valueText" placeholder="Type value...">
    
                        <div v-if="['radio', 'checkbox', 'select', 'multiselect', 'users_list'].indexOf(filtersList[filter.id].type) >= 0" class="form-control-wrapper w-100 mb-2">
                            <div class="">
                                <multiselect
                                    v-model="filters[index].valueArray"
                                    :multiple="true"
                                    :options="filtersList[filter.id].options"
                                    select-label=""
                                    deselect-label=""
                                    label="value"
                                    track-by="value"
                                    class="multiselect-mid"
                                >
                                </multiselect>
                            </div>
                        </div>

                        <div class="mb-2 w-100" v-if="filtersList[filter.id].type == 'date'">
                            <date-picker v-model="filters[index].valueArray" range></date-picker>
                        </div>

                        <div v-if="filtersList[filter.id].type == 'numeric'" class="d-flex align-items-center mb-2">
                            <span class="mr-2">From</span>
                            <input class="form-control--mid form-control" type="number" v-model="filters[index].valueNumbers[0]">
                            <span class="mx-2">to</span>
                            <input class="form-control--mid form-control" type="number" v-model="filters[index].valueNumbers[1]">
                        </div>

                        <a v-if="filters.length > 0 && filters[0].id > 0" @click="removeFilter(index)" class="link-remove link-remove--blue link ml-2"></a>
                    </template>
                </div>
            </div>
            <div class="link-wrapper">
                <div v-if="filters[filters.length - 1].id > 0" @click="addFilter" class="form-custom__action link ml-auto">+ Add Another Filter</div>
            </div>
        </div>
        <template #modal-footer>
            <b-button variant="primary" size="lg" @click="apply">Apply</b-button>
        </template>
    </b-modal>
</template>

<script>

import multiselect from 'vue-multiselect'
import DatePicker from 'vue2-datepicker';

export default {
    props: {
        prefix: {
            type: String,
            default: '',
        },
        filtersList: Object,
        forSearch: {
            type: Boolean,
            default: false,
        },
    },

    components: {
        multiselect,
        DatePicker
    },

    data() {
        return {
            filters: [
                {
                    id: 0,
                    valueText: '',
                    valueArray: [],
                    valueNumbers: [null, null],
                },
            ],
        }
    },

    methods: {
        open() {
            this.$bvModal.show('custom-data-filter' + this.prefix)
        },

        apply() {
            let filters = []

            for (let i in this.filters) {
                let currentFilter = this.filters[i]

                if (currentFilter.id > 0) {
                    let type = this.filtersList[currentFilter.id].type

                    if (type == 'text' || type == 'textarea') {
                        if (currentFilter.valueText.length) {
                            if (this.forSearch) {
                                filters.push(
                                    {
                                        name: 'custom_' + currentFilter.id,
                                        label: this.filtersList[currentFilter.id].name,
                                        value: currentFilter.valueText,
                                        valueAlias: currentFilter.valueText,
                                    }
                                )
                            }
                            else {
                                filters.push(
                                    {
                                        id: currentFilter.id,
                                        value: currentFilter.valueText,
                                        valueAlias: currentFilter.valueText,
                                    }
                                )
                            }
                        }
                        else {
                            this.filters.splice(i, 1)
                        }
                    }

                    else if (['radio', 'checkbox', 'select', 'multiselect', 'tracker', 'users_list'].indexOf(type) >= 0) {
                        if (currentFilter.valueArray.length) {
                            if (this.forSearch) {
                                let values = this.arrayHelper.arrayColumn(currentFilter.valueArray, 'value')
                                filters.push(
                                    {
                                        name: 'custom_' + currentFilter.id,
                                        label: this.filtersList[currentFilter.id].name,
                                        value: values,
                                        valueAlias: values.join(', '),
                                    }
                                )
                            }
                            else {
                                let values = this.arrayHelper.arrayColumn(currentFilter.valueArray, 'id')
                                let names = this.arrayHelper.arrayColumn(currentFilter.valueArray, 'value')
                                filters.push(
                                    {
                                        id: currentFilter.id,
                                        value: values,
                                        valueAlias: names.join(', '),
                                    }
                                )
                            }
                        }
                        else {
                            this.filters.splice(i, 1)
                        }
                    }

                    else if (type == 'date') {
                        if (currentFilter.valueArray.length == 2 && currentFilter.valueArray[0] instanceof Date && currentFilter.valueArray[1] instanceof Date) {
                            let interval = this.dateHelper.decodeInterval(currentFilter.valueArray);

                            if (this.forSearch) {
                                filters.push(
                                    {
                                        name: 'custom_' + currentFilter.id,
                                        label: this.filtersList[currentFilter.id].name,
                                        value: interval,
                                        valueAlias: interval.join('-'),
                                    }
                                )
                            }
                            else {
                                filters.push(
                                    {
                                        id: currentFilter.id,
                                        value: interval,
                                        valueAlias: interval.join('-'),
                                    }
                                )
                            }

                        }
                        else {
                            this.filters.splice(i, 1)
                        }
                    }

                    else if (type == 'numeric') {
                        if (currentFilter.valueNumbers[0] || currentFilter.valueNumbers[1]) {
                            if (this.forSearch) {
                                filters.push(
                                    {
                                        name: 'custom_' + currentFilter.id,
                                        label: this.filtersList[currentFilter.id].name,
                                        value: this.arrayHelper.cloneArray(currentFilter.valueNumbers),
                                        valueAlias: currentFilter.valueNumbers.join('-'),
                                    }
                                )
                            } else {
                                filters.push(
                                    {
                                        id: currentFilter.id,
                                        value: this.arrayHelper.cloneArray(currentFilter.valueNumbers),
                                        valueAlias: currentFilter.valueNumbers.join('-'),
                                    }
                                )
                            }
                        }
                        else {
                            this.filters.splice(i, 1)
                        }
                    }
                }
            }

            this.$emit('updateCustomDataFilter', filters)

            this.$bvModal.hide('custom-data-filter' + this.prefix)

            if (!this.filters.length) {
                this.resetFilters()
            }
        },

        addFilter() {
            this.filters.push(
                {
                    id: 0,
                    valueText: '',
                    valueArray: [],
                    valueNumbers: [null, null],
                }
            )
        },

        removeFilter(index) {
            this.filters.splice(index, 1)
            if (!this.filters.length) {
                this.resetFilters()
            }
        },

        removeFilterById(id) {
            let index = this.arrayHelper.findIndexByColumnValue(this.filters, 'id', id)
            if (index >= 0) {
                this.filters.splice(index, 1)
                if (!this.filters.length) {
                    this.resetFilters()
                }
            }
        },

        resetFilters() {
            this.filters = []
            this.filters.push(
                {
                    id: 0,
                    valueText: '',
                    valueArray: [],
                    valueNumbers: [null, null],
                }
            )
        },

        actualFiltersList(selectedId) {
            let existed = this.arrayHelper.arrayColumn(this.filters, 'id')
            let array = {}

            for (let id in this.filtersList) {
                if (existed.indexOf(id) < 0 || id == selectedId) {
                    array[id] = this.filtersList[id]
                }
            }

            return array
        },

        resetFilter(index) {
            this.filters[index].valueText = ''
            this.filters[index].valueArray = []
            this.filters[index].valueNumbers = [null, null]
        }
    }
}
</script>

<style scoped>

</style>
